import type { CSSProperties, ReactNode } from 'react';

export interface IconProps {
  d: ReactNode;
  size?: number;
  stroke?: number;
  fill?: string;
  style?: CSSProperties;
}

export function Icon({ d, size = 16, stroke = 1.6, fill = 'none', style }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: '0 0 auto', display: 'block', ...style }}
    >
      {d}
    </svg>
  );
}
